export default __webpack_public_path__ + "static/media/certificate3.368d1426.jpg";